import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FilterStatus } from '@app/models/filters/filter-status';
import { GenericFilterConfig } from '@app/models/filters/generic-filter-config';
import { MultiValueFilterConfig } from '@app/models/filters/multi-value-filter-config';

@Component({
	selector: 'app-radio',
	standalone: true,
	imports: [],
	templateUrl: './radio.component.html',
	styleUrl: './radio.component.css',
})
export class RadioComponent {
	@Input() genericConfig: GenericFilterConfig = {} as GenericFilterConfig;
	specificConfig: MultiValueFilterConfig = {} as MultiValueFilterConfig;
	status: FilterStatus = {} as FilterStatus;

	@Output() radioSelected = new EventEmitter<FilterStatus>();

	ngOnInit() {
		// cast generic filter config to specific
		this.specificConfig = this.genericConfig as MultiValueFilterConfig;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['genericConfig']) {
			this.specificConfig = changes['genericConfig'].currentValue as MultiValueFilterConfig;
		}
	}

	onRadioSelect = (event: Event) => {
		let target = event.target as HTMLInputElement;
		let primaryValue = target.value;
		let secondaryValue = target.getAttribute('seondaryValue');

		if (!secondaryValue) {
			secondaryValue = primaryValue;
		}

		this.radioSelected.emit({
			filterId: this.specificConfig.id,
			selectedPrimaryValues: [primaryValue],
			selectedSecondaryValues: [secondaryValue],
		});
	};
}
